export const SUSTAINABILITY_THEME = 'Sustainability';
export const NUTRITION_THEME = 'Nutrition';
export const FITNESS_THEME = 'Fitness';
export const CIVIC_THEMES = [
    'Civic',
    'Diversity & Inclusion',
    'Remote Engagement',
];
